export default {
  coupons: [],
  purchasedCoupons: [],
  couponsInCart: []
}
